import React from 'react'
import classes from './styles.module.scss';

interface ITabsProps {
    tabs: {key: string, label: string}[];
    activeTab: string;
    onTabChange: (tab: string) => void;
}

const Tabs: React.FC<ITabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className={classes.tabs}>
      {tabs.map((tab) => (
        <div
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`${classes.tab} ${tab.key === activeTab ? classes.active : ''}`}
        >
          {tab.label}
        </div>
      ))}
    </div>
  )
}

export default Tabs